export default "__VITE_ASSET__BydlYYFJ__"